import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ChoiceGrid, MultiChoiceGrid, StepFooter, StepHeader, ValueSlider } from "./_widgets";

const TYPES = [
  { value: "weights", label: "Weight Training" },
  { value: "cardio", label: "Cardio" },
  { value: "hiit", label: "HIIT" },
  { value: "sports", label: "Sports" },
  { value: "crossfit", label: "CrossFit" },
  { value: "other", label: "Other" },
];

const EXPERIENCE = [
  { value: "beginner", label: "Beginner", hint: "0-1 year" },
  { value: "intermediate", label: "Intermediate", hint: "1-3 years" },
  { value: "advanced", label: "Advanced", hint: "3+ years" },
];

const ACTIVITY = [
  { value: "sedentary", label: "Sedentary", hint: "Desk job, little movement" },
  { value: "lightly_active", label: "Lightly Active", hint: "Light walks, some chores" },
  { value: "active", label: "Active", hint: "Regular movement on top of training" },
  { value: "very_active", label: "Very Active", hint: "Physical job or high activity" },
];

export default function Step4Training({ data, set, onNext }) {
  const days = data.training_days ?? 3;
  const steps = data.daily_steps ?? 6000;
  const valid =
    days >= 0 &&
    (data.training_types || []).length > 0 &&
    !!data.training_experience &&
    !!data.activity_level &&
    !!data.injuries; // text required — user can say "None"

  return (
    <div className="space-y-5">
      <StepHeader title="Training" subtitle="What does your training week look like?" />

      <div className="space-y-1.5">
        <Label>Days per week you train</Label>
        <ValueSlider
          value={days}
          onChange={(v) => set({ training_days: v })}
          min={0}
          max={7}
          suffix=" days"
          testid="onb-train-days"
        />
      </div>

      <div className="space-y-1.5">
        <Label>What type(s) of training do you do?</Label>
        <MultiChoiceGrid
          options={TYPES}
          value={data.training_types || []}
          onChange={(v) => set({ training_types: v })}
          testid="onb-train-types"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Training experience</Label>
        <ChoiceGrid
          options={EXPERIENCE}
          value={data.training_experience}
          onChange={(v) => set({ training_experience: v })}
          testid="onb-train-experience"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Average daily activity level</Label>
        <ChoiceGrid
          options={ACTIVITY}
          value={data.activity_level}
          onChange={(v) => set({ activity_level: v })}
          testid="onb-activity"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Average daily steps</Label>
        <ValueSlider
          value={steps}
          onChange={(v) => set({ daily_steps: v })}
          min={1000}
          max={20000}
          step={500}
          suffix=" steps"
          testid="onb-steps"
        />
      </div>

      <div className="space-y-1.5">
        <Label>Any injuries or limitations?</Label>
        <Textarea
          rows={2}
          placeholder="e.g. lower back tightness, write 'None' if none"
          value={data.injuries}
          data-testid="onb-injuries"
          onChange={(e) => set({ injuries: e.target.value })}
        />
      </div>

      <StepFooter valid={valid} onNext={onNext} />
    </div>
  );
}
